import * as CartActions from '../actions';

import {createReducer, on} from '@ngrx/store';
import {Cart} from '@app/core/models';

export const CART_INITIAL_STATE: Cart = {
  CartId: 0,
  UserId: 0,
  CouponId: 0,
  CouponApplied: false,
  CouponCode: '',
  SubTotal: 0,
  SubTotalTitle: '',
  Discount: 0,
  DiscountTitle: '',
  TotalAmount: 12,
  TotalAmountTitle: '',
  DeliveryCharge: 0,
  DeliveryChargeTitle: '',
  PaymentMethod: 0,
  Notes: '',
  AddressRequired: false,
  UserCartBranches: [],
  UsersCartsAddresses: '',
  CartPaymentMethodList: [],
  BranchId: 0,
};

export const cartReducer = createReducer(
  CART_INITIAL_STATE,
  on(CartActions.LoadCart, (state, { payload }) => {
    return {
      ...state,
      payload,
    };
  }),
  on(CartActions.AddToCart, (state, { payload }) => {
    return {
      ...state,
      payload,
    };
  }),
  on(CartActions.RemoveFromCart, (state, { payload }) => {
    return {
      ...state,
      payload,
    };
  }),
  on(CartActions.StoreCart, (state, { payload }) => {
    return {
      ...payload,
      payload,
    };
  })
);
